"use client";

import type { PageLoadReadinessSignal } from "@/utils/page-load-telemetry";
import { useEffect } from "react";

export const routeReadyTelemetryEventName = "atlas:route-ready";

export type RouteOwnedReadinessSignal = Extract<
  PageLoadReadinessSignal,
  "list_content_ready" | "profile_overview_ready" | "profile_shell_ready"
>;

export function RouteReadyTelemetry({
  enabled = true,
  signal,
}: {
  enabled?: boolean;
  signal: RouteOwnedReadinessSignal;
}) {
  useEffect(() => {
    if (!enabled || process.env.NODE_ENV !== "production") {
      return;
    }

    let secondFrame: number | null = null;
    const firstFrame = requestAnimationFrame(() => {
      secondFrame = requestAnimationFrame(() => {
        window.dispatchEvent(
          new CustomEvent(routeReadyTelemetryEventName, {
            detail: { signal },
          }),
        );
      });
    });

    return () => {
      cancelAnimationFrame(firstFrame);
      if (secondFrame !== null) {
        cancelAnimationFrame(secondFrame);
      }
    };
  }, [enabled, signal]);

  return null;
}
